/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Finals_Seating_Procedure_HintInputs */



/**
* | output |
* | --- |
* | "VEKN procedure: from the lowest seed up, each finalist puts their name card at either end of the row or between two cards. Seats read left to right." |
*
* @param {Finals_Seating_Procedure_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const finals_seating_procedure_hint = /** @type {((inputs?: Finals_Seating_Procedure_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Finals_Seating_Procedure_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Procédure VEKN : de la tête de série la plus basse à la plus haute, chaque finaliste pose sa carte nominative à un bout de la rangée ou entre deux cartes. Les sièges se lisent de gauche à droite.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Procedimiento VEKN: de la cabeza de serie más baja a la más alta, cada finalista coloca su tarjeta en un extremo de la fila o entre dos tarjetas. Los asientos se leen de izquierda a derecha.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Procedimento VEKN: da cabeça de chave mais baixa para a mais alta, cada finalista põe seu cartão em uma ponta da fileira ou entre dois cartões. Os lugares são lidos da esquerda para a direita.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Procedura VEKN: dalla testa di serie più bassa alla più alta, ogni finalista mette il proprio cartellino a un capo della fila o tra due cartellini. I posti si leggono da sinistra a destra.")
	return /** @type {LocalizedString} */ ("VEKN procedure: from the lowest seed up, each finalist puts their name card at either end of the row or between two cards. Seats read left to right.")
});